// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { SvgIconName } from './svg-icon-name';

type SvgSizePresetKey =
  | "smaller"
  | "small"
  | "medium-small"
  | "default"
  | "medium-large"
  | "large"
  | "larger"
  | "largest";

/** To prepare an svg icon for use with this component, see tools/icon-preparer/README.md */
@Component({
  selector: "app-svg-icon",
  templateUrl: "./svg-icon.component.html",
  styleUrls: ["./svg-icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent implements OnChanges {
  private static iconsBasePath = "/ng-assets/img/icons/";

  public link = "";

  private sizePresets = new Map<SvgSizePresetKey, string>([
    ["smaller", "0.6rem"],
    ["small", "0.9rem"],
    ["medium-small", "1.25rem"],
    ["default", "1.5rem"],
    ["medium-large", "1.75rem"],
    ["large", "2rem"],
    ["larger", "2.5rem"],
    ["largest", "3.5rem"],
  ]);

  @Input() size: SvgSizePresetKey = "default";
  @Input({required: true}) type: SvgIconName;
  @Input() color = "currentColor";
  @Input() customHeight = "";
  @Input() customWidth = "";

  /** when inline is set to true, the size will be ignored, the icon will be inlined and centered to the text */
  @HostBinding("class.inline-icon") @Input() inline: boolean = false;

  @HostBinding("style.width") cssWidth = "1.5rem";
  @HostBinding("style.height") cssHeight = "1.5rem";

  ngOnChanges(): void {
    this.link = SvgIconComponent.iconsBasePath + `${this.type}.svg#${this.type}`;
    if(this.inline) {
      this.cssWidth = "1em";
      this.cssHeight = "1em";
    } else {
      const cssSize: string = this.sizePresets.get(this.size);
      this.cssWidth = this.customWidth != "" ? this.customWidth : cssSize;
      this.cssHeight = this.customHeight != "" ? this.customHeight : cssSize;
    }
  }
}
